function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import classNames from 'classnames';
import { Button, LoadingSpinner } from '@deephaven/components';
import { vsClose } from '@deephaven/icons';
import { TimeUtils } from '@deephaven/utils';
import "./ConsoleHistoryResultInProgress.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A spinner shown when a command is taking a while.
 */
class ConsoleHistoryResultInProgress extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "startTime", void 0);
    this.updateElapsed = this.updateElapsed.bind(this);
    this.startTime = Date.now();
    this.state = {
      elapsed: 0
    };
  }
  componentDidMount() {
    this.timer = window.setInterval(this.updateElapsed, 1000);
  }
  componentWillUnmount() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }
    this.timer = undefined;
  }
  updateElapsed() {
    this.setState({
      elapsed: Math.round((Date.now() - this.startTime) / 1000)
    });
  }
  render() {
    var _this$props = this.props,
      disabled = _this$props.disabled,
      onCancelClick = _this$props.onCancelClick;
    var elapsed = this.state.elapsed;
    return /*#__PURE__*/_jsx("div", {
      className: classNames('console-history-result-in-progress', {
        disabled
      }),
      children: /*#__PURE__*/_jsxs("span", {
        className: "badge",
        children: [/*#__PURE__*/_jsx(LoadingSpinner, {
          className: "ml-2"
        }), "Running... ", TimeUtils.formatElapsedTime(elapsed), "\xA0", /*#__PURE__*/_jsx(Button, {
          className: "console-history-result-in-progress-cancel",
          kind: "ghost",
          icon: vsClose,
          tooltip: "Cancel",
          onClick: onCancelClick,
          disabled: disabled
        })]
      })
    });
  }
}
_defineProperty(ConsoleHistoryResultInProgress, "defaultProps", {
  disabled: false
});
export default ConsoleHistoryResultInProgress;
//# sourceMappingURL=ConsoleHistoryResultInProgress.js.map